// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptionList_container__YugEO"};